

define(['jquery', 'squid', 'text!./template.html', '../shipping-address/directive'], function ($, squid, template) {

    return squid.module('xo-select-shipping.add-shipping.directive', ['squid', 'xo-shipping-address.directive']).directive('xoAddShipping', function () {

        return {
            template: template,

            scope: {
                auth: '=',
                token: '=',
                doneFn: '=',
                sidebar: '=',
                update: '='
            },

            controller: function controller($scope) {}
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/select-shipping/add-shipping/directive.js
// module id = ./components/xo-member-components/src/select-shipping/add-shipping/directive.js
// module chunks = 1